import http from "../http"
import { Activity } from "../../models/activity"

interface GetActivitiesParams {
    page?: number;
    pageSize?: number;
    userId?: string;
    modelType?: string;
    modelId?: string;
}

interface GetActivitiesResponse {
    data: Activity[];
    meta: {
        page: number;
        pageSize: number;
        totalPages: number;
        total: number;
    };
}

class ActivityService {
    private readonly baseUrl = "/admin/activity"

    async getActivities(params?: GetActivitiesParams) {
        const { data } = await http.get<GetActivitiesResponse>(this.baseUrl, { params })
        return data
    }
}

export default new ActivityService()
